export enum PaymentAction {
  SET_DEPOSIT_HISTORY = "setDepositHistory",
  SET_DEPOSIT_HISTORY_COUNT = "setDepositHistoryCount",
  SET_WITHDRAWAL_HISTORY = "setWithdrawalHistory",
  SET_WITHDRAWAL_HISTORY_COUNT = "setWithdrawalHistoryCount",
  SET_PAYMENT_METHODS = "setPaymentMethods",
  SET_PAYMENT_LOADING = "setPaymentLoading",
  SET_PAYMENT_MESSAGE = "setPaymentMessage",
}
